import { Dimensions } from 'react-native';

export const filterPopoverProps = {
    width: Dimensions.get('window').width / 2,
}